import { v1ApiClient } from '@/services';
import type { PathParams } from '@/shared/api/generated';

import type { HelpscoutMailbox } from '../model';

type MailboxesPath = '/v1/workspaces/{workspace_id}/helpscout/mailboxes';

/**
 * Helpscout mailbox 목록 조회
 */
export const getHelpscoutMailboxes = async ({
  workspace_id,
}: PathParams<MailboxesPath, 'get'>): Promise<HelpscoutMailbox[]> => {
  const res = await v1ApiClient.get<HelpscoutMailbox[]>(
    `/workspaces/${workspace_id}/helpscout/mailboxes`,
  );

  return res.data.map((mailbox) => ({
    ...mailbox,
    id: String(mailbox.id),
  }));
};
